"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = Header;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BurgerIcon = _interopRequireDefault(require("./BurgerIcon"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledHeader = _styledComponents["default"].header(_templateObject || (_templateObject = _taggedTemplateLiteral(["\nbackground: var(--primary-surface, #FFF);\ncolor: var(--on-primary-surface, #000);\nmin-height: 5rem;\npadding: 0.5rem 1rem;\ndisplay: grid;\ngrid-template-columns: 25% 1fr;\nbox-shadow: var(--box-shadow-9dp, 0 9px 12px 1px rgba(0,0,0,0.14), 0 3px 16px 2px rgba(0,0,0,0.12), 0 5px 6px -3px rgba(0,0,0,0.20));\nz-index: var(--header-z-index, 500);\nposition: relative;\n\n& > picture {\n    display: grid;\n    place-items: center;\n}\n\n.burger-icon {\n    display: none;\n}\n"])));

var LogoContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\ndisplay: grid;\ngrid-template-columns: 2rem 1fr;\n\npicture {\n    display: grid;\n    place-items: center;\n}\n"])));

function Header(_ref) {
  var logo = _ref.logo,
      logoText = _ref.logoText,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(StyledHeader, null, /*#__PURE__*/_react["default"].createElement("picture", {
    className: "burger-icon"
  }, /*#__PURE__*/_react["default"].createElement(_BurgerIcon["default"], {
    width: "1rem"
  })), /*#__PURE__*/_react["default"].createElement(LogoContainer, null, /*#__PURE__*/_react["default"].createElement("picture", null, logo), /*#__PURE__*/_react["default"].createElement("h4", null, logoText)), /*#__PURE__*/_react["default"].createElement("div", null, children));
}